"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PluggableElementBase {
    constructor(args) {
        this.name = args.name || 'UNKNOWN';
        this.maybeDisplayName = args.displayName;
    }
    get displayName() {
        return this.maybeDisplayName || this.name;
    }
}
exports.default = PluggableElementBase;
